export const maskCnpj = (value: string) => {
    // 1. Limpeza inicial: Aceita letras e n�meros
    let cleanValue = value.replace(/[^a-zA-Z0-9]/g, '');

    // 2. Valida��o H�brida: caracteres 13 e 14 (final) DEVEM ser n�meros. Se o digitar letra no final, remove antes de aplicar a m�scara.
    if (cleanValue.length > 12) {
        const part1 = cleanValue.substring(0, 12);
        const part2 = cleanValue.substring(12, 14).replace(/\D/g, ''); // Remove n�o-d�gitos do final
        cleanValue = part1 + part2;
    }

    // 3. Aplica a M�scara
    return cleanValue
        .replace(/^([a-zA-Z0-9]{2})([a-zA-Z0-9])/, '$1.$2')
        .replace(/^([a-zA-Z0-9]{2})\.([a-zA-Z0-9]{3})([a-zA-Z0-9])/, '$1.$2.$3')
        .replace(/\.([a-zA-Z0-9]{3})([a-zA-Z0-9])/, '.$1/$2')
        .replace(/\/([a-zA-Z0-9]{4})([0-9])/, '/$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
};

export const maskCpf = (value?: string) => {
  if (!value) return '';
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
};

export const maskCurrency = (value?: string) => {
  if (!value) return 'R$ 0,00';
  return parseFloat(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

export const maskRg = (value?: string) => {
  if (!value) return '';
  value = value.replace(/\D/g, '');
  value = value.replace(/(\d{2})(\d{3})(\d{3})(\d{1})(\d*)$/, '$1.$2.$3-$4');
  return value;
};

export const maskPhone = (value?: string) => {
  if (!value) return '';
  value = value.replace(/\D/g, '');
  if (value.length === 10)
    value = value.replace(/(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
  else value = value.replace(/(\d{2})(\d{5})(\d{4})(\d*)$/, '($1) $2-$3');

  return value;
};

export const unmask = (value?: string) => {
  if (!value) return '';
  return value.replace(/\D/g, '');
};
